import { render, staticRenderFns } from "./RoleConfigWindow.vue?vue&type=template&id=84d5abe8&scoped=true"
import script from "./RoleConfigWindow.vue?vue&type=script&lang=js"
export * from "./RoleConfigWindow.vue?vue&type=script&lang=js"
import style0 from "./RoleConfigWindow.vue?vue&type=style&index=0&id=84d5abe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d5abe8",
  null
  
)

export default component.exports